export default {
  setAllAttributes (state, data) {
    state.allAttributes = data
  },
  setRelatedAttributeData (state, data) {
    state.relatedAttributeData = data
  },
  setAttributesActive (state, data) {
    state.attributesActive = data
  },
  setListingAttributeGroupCombos (state, data) {
    state.listingAttributeGroupCombos = data
  },
  setAttributeFilterQueryStringVar (state, data) {
    state.attributeFilterQueryStringVar = data
  },
  setActiveAttributeFilters (state, data) {
    if (data === null) {
      data = []
    }
    state.activeAttributeFilters = data
  },
  setAttributeRecordsUsed (state, data) {
    state.attributeRecordsUsed = data
  },
  setProductAttributeInfoData (state, data) {
    state.productAttributeInfoData = data
  }
}
